if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.replaceLast
) {
  Object.defineProperty(String.prototype, 'replaceLast', {
    value(find, replace) {
      var index = this.lastIndexOf(find);
      if (index >= 0) {
        return this.substring(0, index) + replace + this.substring(index + find.length);
      }
      return this.toString();
    }
  });
}